import React, { ReactElement, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Avatar, Box, Button, Tab, Tabs, Typography } from '@mui/material'

import { useAppSelector } from 'src/store/hooks'
import { selectRoles, selectUseEvents } from 'src/v3/settings/settings.slice'
import { selectActiveEvent } from 'src/v3/events/events.slice'
import Syllabus from 'src/v3/events/syllabus'
import Sessions from 'src/v3/events/sessions'
import Quiz from 'src/v3/events/quiz'
import { EventForm } from './event-form'
import { LeftArrowIcon } from '../core/icons'
import { EventWizardStep } from './types'

export default (): ReactElement => {
  let navigate = useNavigate()

  let useEvents = useAppSelector(selectUseEvents)
  let roles = useAppSelector(selectRoles)
  let isAdmin = roles.includes('admin')
  let activeEvent = useAppSelector(selectActiveEvent)

  let [step, setStep] = useState<EventWizardStep>('details')

  return useEvents ? (
    <>
      <Tabs
        variant="fullWidth"
        value={step}
        onChange={activeEvent ? (_, value) => setStep(value) : undefined}
      >
        {[
          { step: 'details', label: 'Event Details' },
          { step: 'syllabus', label: 'Syllabus' },
          { step: 'sessions', label: 'Sessions' },
          { step: 'quiz', label: 'Quiz' },
        ]
          .filter((tab) => !(!isAdmin && tab.step === 'syllabus'))
          .map((tab, i) => (
            <Tab
              key={tab.step}
              value={tab.step}
              label={tab.label}
              icon={
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    fontSize: 16,
                    color: step === tab.step ? undefined : 'text.secondary',
                    bgcolor:
                      step === tab.step ? 'primary.main' : 'background.paper',
                  }}
                >
                  {i + 1}
                </Avatar>
              }
              iconPosition="start"
              sx={{
                my: -1,
                cursor: activeEvent ? 'pointer' : 'auto',
                textTransform: 'none',
              }}
            />
          ))}
      </Tabs>
      <Box sx={{ my: 5, display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
            Create New Event
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Set up your event details, sessions, and quiz
          </Typography>
        </Box>
        <Button
          sx={{
            alignSelf: 'stretch',
            color: 'text.primary',
            mr: 0.5,
          }}
          startIcon={<LeftArrowIcon />}
          onClick={() => navigate('/events')}
        >
          Back to Events List
        </Button>
      </Box>
      {step === 'details' && (
        <EventForm setStep={setStep} event={activeEvent} />
      )}
      {step === 'syllabus' && <Syllabus setStep={setStep} />}
      {step === 'sessions' && <Sessions setStep={setStep} eventView="edit" />}
      {step === 'quiz' && <Quiz setStep={setStep} />}
    </>
  ) : (
    <></>
  )
}
